import { withInstall } from '@ll-plus/utils'

import CropperImage from './src/cropper-image.vue'
import CropperModal from './src/cropper-modal.vue'

export const LlCropperImage = withInstall(CropperImage)
export const LlCropperModal = withInstall(CropperModal)

export * from './src/cropper-image'

declare module 'vue' {
  export interface GlobalComponents {
    LlCropperImage: typeof CropperImage
    LlCropperModal: typeof CropperModal
  }
}
